/*
 * Doel ── Motion runtime（Claude Design v3）
 * --------------------------------------------------------------------
 * 役割は 2 つだけ：
 *   1) .m-reveal / .m-reveal-group をビューポート進入時に一度だけ .is-in 付与（IntersectionObserver）
 *   2) [data-parallax] 要素を rAF 間引きの translate3d で控えめに視差移動（任意・限定適用）
 *
 * ★ 固まり対策（themes/HANDOFF.md §28.4）：
 *   - 観測の初期化は first paint 後（rAF）に回し、遷移直後の初期化 long task に積まない。
 *   - IO は一度発火で unobserve。常駐コストを残さない。
 *   - パララックスは rAF throttle ＋ passive ＋ 画面外 early-return。transform のみ更新（再ペイントなし）。
 *   - JS 未対応・例外時は全要素を即可視にするフォールバック（コンテンツが消えたまま残らない）。
 *   - reduce 環境では html.doel-anim が付かない＝この runtime は何もしない（CSS 側で静止）。
 */
(function () {
  'use strict';

  var root = document.documentElement;

  // reduce / 非対応 / 何らかの理由で anim 無効 → 全要素を確実に可視化して終了
  function revealAll() {
    var nodes = document.querySelectorAll('.m-reveal, .m-reveal-group');
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-in');
  }

  if (!root.classList.contains('doel-anim') || !('IntersectionObserver' in window)) {
    revealAll();
    return;
  }

  var io = null;

  function setupReveal() {
    var targets = document.querySelectorAll('.m-reveal:not(.is-in), .m-reveal-group:not(.is-in)');
    if (!targets.length) return;
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            entries[i].target.classList.add('is-in');
            io.unobserve(entries[i].target);
          }
        }
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    }
    for (var j = 0; j < targets.length; j++) io.observe(targets[j]);
  }

  // ---- パララックス（限定適用・rAF 間引き）-------------------------------
  function setupParallax() {
    var els = document.querySelectorAll('[data-parallax]');
    if (!els.length) return;
    // 一度だけ scale を当て、以降はスクロールで translate のみ更新（再ペイント回避）
    var scale = 1.06;
    var ticking = false;

    function update() {
      var vh = window.innerHeight;
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) continue; // 画面外はスキップ
        var speed = parseFloat(el.getAttribute('data-parallax')) || 0.12;
        var range = parseFloat(
          getComputedStyle(root).getPropertyValue('--m-parallax')
        ) || 24;
        var progress = (r.top + r.height / 2 - vh / 2) / vh; // -0.5〜0.5 付近
        var offset = -progress * range * speed * 8;
        el.style.transform = 'translate3d(0,' + offset.toFixed(2) + 'px,0) scale(' + scale + ')';
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function init() {
    try {
      setupReveal();
      setupParallax();
    } catch (e) {
      revealAll();
    }
  }

  // first paint 後に初期化（遷移直後の init burst に積まない）
  function deferInit() {
    if ('requestAnimationFrame' in window) {
      requestAnimationFrame(function () { requestAnimationFrame(init); });
    } else {
      init();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', deferInit, { once: true });
  } else {
    deferInit();
  }

  // 安全網：万一 IO が発火しないまま放置されても、コンテンツは必ず出す
  setTimeout(revealAll, 2500);

  // テーマエディタでのセクション再描画時に再スキャン
  document.addEventListener('shopify:section:load', function () {
    try { setupReveal(); setupParallax(); } catch (e) { revealAll(); }
  });
})();
